import * as Yup from 'yup';

export const validationSchemaCategories = new Yup.ObjectSchema({
    business_type: Yup.string().required('Business type is required'),
    customer_alias: Yup.string().required('Cuatomer label is required'),
    staff_alias: Yup.string().required('Staff label is required'),
});

export const initialValuesCategories = {
    business_type:'',
    customer_alias:'',
    staff_alias:'',
}

export const feildsCategories = [
    {
        name:'business_type',
        placeHolder:'Enter your Business type',
        id:'business_type',
        type:'text',
        label:'Business Type'
    },
    {
        name:'customer_alias',
        placeHolder:'Enter your Customer label',
        id:'customer_alias',
        type:'text',
        label:'Customer Label'
    },
    {
        name:'staff_alias',
        placeHolder:'Enter your Staff label',
        id:'staff_alias',
        type:'text',
        label:'Staff Label'
    },
];